import { farmersIcon, landIcon } from './articles';
import Ivr from '../assets/icons/Vector.svg';

const IVR = [
  {
    id: 'ivr',
    stats: {
      farmer: {
        icon: farmersIcon,
        counter: 250341,
        info: 'Farmers profiled',
      },
      land: {
        icon: landIcon,
        counter: 118300,
        info: 'Hectares of farmland mapped',
      },
      ivr: {
        icon: Ivr,
        counter: 23299,
        info: 'IVR users',
      },
    },
  },
];

export default IVR;
